import Vue from "vue/dist/vue.esm.js";
import VueRouter from "vue-router";
import store from "../store";

Vue.use(VueRouter);

// 框架级路由
const routes = [
    {
        path: "/",
        redirect: "/login"
    },
    {
        path: "/login",
        name: "login",
        component: () => import("../views/login/Login.vue")
    },
    {
        path: "/register",
        name: "Register",
        component: () => import("../views/login/Register.vue")
    },
    {
        path: "/main",
        name: "main",
        redirect: "/main/home",
        component: () => import("../views/main/Main.vue"),
        children: [
            {
                path: "home",
                name: "home",
                component: () => import("../views/main/Home.vue"),
                beforeEnter: (to, from, next) => {
                    if (store.state.user.userInfo) {
                        next();
                    } else {
                        next({
                            name: "login"
                        });
                    }
                }
            },
            {
                path: "dwinfo",
                name: "DwInfo",
                component: () => import("../views/main/userInfo/DwInfo.vue")
            },
            {
                path: "jcgl/jcqklr/jcqklr",
                name: "JcqklrRoute",
                component: () => import("../views/main/jcgl/jcqklr/JcqklrRoute.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "jsry/jsrydj/jsrydj",
                name: "jsrydj",
                component: () => import("../views/main/jsry/jsrydj/jsrydj/Jsrydj.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "zxdw/hyrhgl/rhsq",
                name: "rhsq",
                component: () => import("../views/main/zxdw/hyrhgl/rhsq/Rhsq.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "zxdw/dwxxbg/dwxxbgsq",
                name: "dwxxbgsq",
                component: () => import("../views/main/zxdw/dwxxbg/dwxxbgsq/Dwxxbgsq.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "zxdw/dwzcgl/dwzcsq",
                name: "dwxzcsq",
                component: () => import("../views/main/zxdw/dwzcgl/dwzcsq/Dwzcsq.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "zxdw/dwxxbg/dwzxbgsq",
                name: "dwzxbgsq",
                component: () => import("../views/main/zxdw/dwxxbg/dwzxbgsq/Dwzxbgsq.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "zxdw/hkgl/hkxxcx",
                name: "hkxxcx",
                component: () => import("../views/main/zxdw/hkgl/hkxxcx/Hkxxcx.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "zxdw/tggl/tgsq",
                name: "tgsq",
                component: () => import("../views/main/zxdw/tggl/tgsq/Tgsq.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "jsry/jsrybg/jsrybg",
                name: "jsrybg",
                component: () => import("../views/main/jsry/jsrybg/jsrybg/Jsrybg.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "jsry/jsryzcxxbg/jsryzcxxbg",
                name: "jsryzcxxbg",
                component: () => import("../views/main/jsry/jsryzcxxbg/jsryzcxxbg/Jsryzcxxbg.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "jsry/jsryzx/jsryzxwh",
                name: "jsryzxwh",
                component: () => import("../views/main/jsry/jsryzx/jsryzxwh/Jsryzxwh.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "jsry/pxbmgl/pxbmbs",
                name: "pxbmbs",
                component: () => import("../views/main/jsry/pxbmgl/pxbmBS/Pxbm.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "jsry/pxyjfk/pxyjfk",
                name: "pxyjfk",
                component: () => import("../views/main/jsry/pxyjfk/pxyjfk/Pxyjfk.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "jsry/jsrymd",
                name: "jsrymd",
                component: () => import("../views/main/jsry/jsrymd/Jsrymd.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "zxcggl/cgsbgl/cgsbwh",
                name: "cgsbwh",
                component: () => import("../views/main/zxcggl/cgsbgl/cgsbwh/Cgsbwh.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            // 成果公示
            {
                path: "zxcggl/cggs/cggscx",
                name: "cggscx",
                component: () => import("../views/main/zxcggl/cggs/Cggscx.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "hydcgl/hydc/ywfzqkdj",
                name: "ywfzqkdj",
                component: () => import("../views/main/hydcgl/hydc/ywfzqkdj/Ywfzqkdj.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "hydcgl/dwdc/dwdcqkdj",
                name: "dwdcqkdj",
                component: () => import("../views/main/hydcgl/dwdc/dwdcqkdj/Dwdcqkdj.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "zjxx/zjrkgl/zjxxrk",
                name: "zjxxrk",
                component: () => import("../views/main/zjxx/zjrkgl/zjxxrk/Zjxxrk.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "zjxx/zjxxbg/zjxxbglr",
                name: "zjxxbglr",
                component: () => import("../views/main/zjxx/zjxxbg/zjxxbglr/Zjxxbglr.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "dwdcgl/dwdc/dwdcblr",
                name: "dwdcblr",
                component: () => import("../views/main/dwdcgl/dwdc/dwdcblr/Dwdcblr.vue")
            },
            {
                path: "dwdcgl/gzzjgl/gzzjwh",
                name: "gzzjwh",
                component: () => import("../views/main/dwdcgl/gzzjgl/gzzjwh/Gzzjwh.vue")
            },
            {
                path: "hybm/hybmb",
                name: "hybmb",
                component: () => import("../views/main/hybm/bmlr/Bmlr.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            //证书打印
            {
                path: "zsdy/dwzsdy",
                name: "dwzsdy",
                component: () => import("../views/main/zsdy/dwzsdy/Dwzsdy.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            //专家证书打印
            {
                path: "zsdy/zjzsdy",
                name: "zjzsdy",
                component: () => import("../views/main/zsdy/zjzsdy/Zjzsdy.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: "dwzx/dwzx/zxdj",
                name: "zxdj",
                component: () => import("../views/main/dwzx/dwzx/zxdj/Zxdj.vue"),
                meta: {
                    requiresAuth: true
                }
            },
            //通知公告
            {
                path: "oagl/tzgl/tzggcx",
                name: "tzggcx",
                component: () => import("../views/main/oagl/tzgl/tzggcx/Tzggcx.vue"),
                meta: {
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: "/jsaec/szxdwfwpt/zczxdwzxcx",
        name: "zczxdwzxcx",
        component: () => import("../views/jsaec/szxdwfwpt/zczxdwzxcx/Zczxdwzxcx.vue")
    },
    {
        path: "/jsaec/szxdwfwpt/zczxgcscx",
        name: "zczxgcscx",
        component: () => import("../views/jsaec/szxdwfwpt/zczxgcscx/Zczxgcscx.vue")
    },
    {
        path: "/jsaec/gczx/login",
        name: "jsaecLogin",
        component: () => import("../views/jsaec/gczx/login/Login.vue")
    },
    {
        path: "/jsaec/gczx/list",
        name: "jsaecList",
        component: () => import("../views/jsaec/gczx/page/List.vue")
    },
    {
        path: "/jsaec/gczx/hy",
        name: "jsaecHyXQ",
        component: () => import("../views/jsaec/gczx/page/HyXQ.vue")
    },
    {
        path: "/jsaec/gczx/fhy",
        name: "jsaecFhyXQ",
        component: () => import("../views/jsaec/gczx/page/FhyXQ.vue")
    },
    {
        path: "/403",
        name: "403",
        component: () => import("../views/error/403.vue")
    },
    {
        path: "*",
        name: "404",
        component: () => import("../views/error/404.vue")
    }
];

const router = new VueRouter({
    mode: "hash",
    routes
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};

// 递归方式
function checkMenuRight(menus, path) {
    if (menus) {
        if (path.indexOf("?") > -1) {
            path = path.substring(0, path.indexOf("?"));
        }
        for (let i = 0; i < menus.length; i++) {
            if (menus[i].children && menus[i].children.length > 0) {
                if (checkMenuRight(menus[i].children, path)) {
                    return true;
                }
            } else if (menus[i].fun_entry === path) {
                return true;
            }
        }
    }
}

// 全局路由守卫
router.beforeEach((to, from, next) => {
    // 路由需要鉴权
    if (to.meta.requiresAuth) {
        if (store.state.user.userInfo) {
            if (checkMenuRight(store.state.user.userMenus, to.fullPath)) {
                next();
            } else {
                // 导向无权限界面
                next({
                    name: "403"
                });
            }
        } else {
            next({
                name: "login"
            });
        }
    } else {
        next();
    }
});

export default router;
